import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
@Injectable({
  providedIn: 'root',
})
export class OtherProjectStatusDataGridService {
  otherProjectStatusDataPayload: any;
  event: any;
  activatedRoute: any;

  editProjectStatusData = new Subject<[any, any, any]>();
  projectStatusObservable$ = this.editProjectStatusData.asObservable();

  deleteProjectStatusData = new Subject<[any, any, any]>();
  ProjectStatusDataDeleteObservable$ = this.deleteProjectStatusData.asObservable();
  constructor(private AdministratorFacade: AdministratorFacade, private swalService: SwalService) {}

  getOtherProjectStatusDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'position',
      headerName: 'position',
      field: 'position',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Project status',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: (params: any, pathName: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        if (!params.data.isSystem) cellElement.style.cursor = 'pointer';
        if (!params.data.isSystem) cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          if (
            params.columnApi.columnModel.columnDefs[
              params.columnApi.columnModel.columnDefs.length - 1
            ].cellRendererParams?.showEdit &&
            !params.data.isSystem
          )
            this.editProjectStatusData.next([
              params.data.statusId,
              'Review project status detail',
              location.href.split('/')[7],
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'IsPublic',
      headerName: 'Public',
      field: 'isPublic',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showCopy: false,
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        deleteData: (data: any, pathName: any) => {
          this.deleteProjectStatusConfirmation(
            data.statusId,
            '/ProjectStatus/DeleteProjectStatus?id',
            pathName
          );
        },
        editData: (data: any, pathName: any) => {
          this.editProjectStatusData.next([
            data.statusId,
            'Review project status detail',
            pathName,
          ]);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageOtherDataProjectStatus,
      subModuleName.otherDataModule
    );
  };

  deleteProjectStatusConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteProjectStatusData.next([data, customType, pathName]);
      }
    });
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getOtherProjectStatusDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions' && value?.name != 'IsPublic');

    return (this.otherProjectStatusDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'position',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
